var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 180,
    viewBox: "0 0 186 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 95.5,
    cy: 90.5,
    r: 70.5,
    fill: "url(#paint0_linear_190_4075)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7575 68H105.265C112.892 68 118 73.355 118 81.32V99.7048C118 107.645 112.892 113 105.265 113H85.7575C78.13 113 73 107.645 73 99.7048V81.32C73 73.355 78.13 68 85.7575 68ZM94.2197 97.2231L104.907 86.5356C105.672 85.7706 105.672 84.5331 104.907 83.7456C104.142 82.9806 102.882 82.9806 102.117 83.7456L92.8247 93.0381L88.8872 89.1006C88.1222 88.3356 86.8622 88.3356 86.0972 89.1006C85.3322 89.8656 85.3322 91.1031 86.0972 91.8906L91.4522 97.2231C91.8347 97.6056 92.3297 97.7856 92.8247 97.7856C93.3422 97.7856 93.8372 97.6056 94.2197 97.2231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    cx: 178.461,
    cy: 27.5,
    r: 7.5,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    cx: 20.0312,
    cy: 10,
    r: 10,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    cx: 10.0312,
    cy: 133,
    r: 5,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    cx: 165.531,
    cy: 160.5,
    r: 2.5,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    cx: 106.531,
    cy: 4.5,
    r: 2.5,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    cx: 62.5312,
    cy: 176.5,
    r: 3.5,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    cx: 122.031,
    cy: 171,
    r: 1,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    cx: 170.531,
    cy: 110.5,
    r: 2.5,
    fill: "#A592FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    cx: 1.03125,
    cy: 75,
    r: 1,
    fill: "#A592FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_190_4075",
    x1: 166,
    y1: 161,
    x2: -1.77734,
    y2: 112.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6949FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#876DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckVector);
export default __webpack_public_path__ + "static/media/checkVector.c2ba0fdfe8c4baf152c72f24dd4a0ff2.svg";
export { ForwardRef as ReactComponent };